import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["containerSelect", "containerVariantSelect", "wickTypeSelect", "wickVariantSelect", "numberOfWicksInput", "wickRecommendation"]
  static values = {
    containers: Array,
    containerVariants: Array,
    wicks: Array,
    wickVariants: Array
  }

  connect() {
    console.log('Perfumed candle variant form controller connected')

    // If we're in edit mode and there's a container selected, populate all its variants
    if (this.hasContainerSelectTarget && this.containerSelectTarget.value) {
      this.updateContainerVariants()
    }

    // If there's a selected wick type, populate wick variants
    if (this.hasWickTypeSelectTarget && this.wickTypeSelectTarget.value) {
      this.populateWickVariants(parseInt(this.wickTypeSelectTarget.value))
    }

    // Auto-select recommended wick if container variant is selected
    if (this.hasContainerVariantSelectTarget && this.containerVariantSelectTarget.value) {
      setTimeout(() => {
        this.selectRecommendedWick()
      }, 100)
    }
  }

  updateContainerVariants() {
    const containerId = this.containerSelectTarget.value
    const containerVariantSelect = this.containerVariantSelectTarget
    const currentValue = containerVariantSelect.value

    // Clear current options
    containerVariantSelect.innerHTML = '<option value="">Select a variant</option>'

    if (containerId) {
      // Filter variants for selected container
      const variants = this.containerVariantsValue.filter(v => v.container_id == containerId)

      variants.forEach(variant => {
        const option = document.createElement('option')
        option.value = variant.id
        option.textContent = variant.display_name
        // Restore the previously selected value if it exists
        if (variant.id.toString() === currentValue) {
          option.selected = true
        }
        containerVariantSelect.appendChild(option)
      })

      containerVariantSelect.disabled = false
    } else {
      containerVariantSelect.disabled = true
    }
  }

  updateWickVariants(event) {
    const wickId = parseInt(event.target.value)
    this.populateWickVariants(wickId)
  }

  populateWickVariants(wickId) {
    const wickVariantSelect = this.wickVariantSelectTarget
    const currentValue = wickVariantSelect.value

    // Clear current options
    wickVariantSelect.innerHTML = '<option value="">Select a wick variant</option>'

    if (!wickId) {
      wickVariantSelect.disabled = true
      return
    }

    // Filter wick variants for selected wick (only poured candles)
    const variants = this.wickVariantsValue.filter(wv => wv.wick_id === wickId && wv.wick.candle_type === 'poured')

    // Add variant options
    variants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name_with_stock
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      wickVariantSelect.appendChild(option)
    })

    // Enable the select
    wickVariantSelect.disabled = false
  }

  selectRecommendedWick() {
    const variantId = parseInt(this.containerVariantSelectTarget.value)
    if (!variantId) {
      // Hide recommendation if no variant selected
      if (this.hasWickRecommendationTarget) {
        this.wickRecommendationTarget.style.display = 'none'
      }
      return
    }

    const variant = this.containerVariantsValue.find(v => v.id === variantId)

    // Set number of wicks from container variant
    if (variant && variant.number_of_wicks && this.hasNumberOfWicksInputTarget) {
      this.numberOfWicksInputTarget.value = variant.number_of_wicks
    }

    // Auto-select recommended wick if available
    if (variant && variant.recommended_wick_variant_id) {
      const recommendedWickVariant = this.wickVariantsValue.find(wv => wv.id === variant.recommended_wick_variant_id)

      if (recommendedWickVariant) {
        // First, select the wick type
        if (this.hasWickTypeSelectTarget) {
          this.wickTypeSelectTarget.value = recommendedWickVariant.wick_id
          this.populateWickVariants(recommendedWickVariant.wick_id)
        }

        // Then select the wick variant
        setTimeout(() => {
          this.wickVariantSelectTarget.value = variant.recommended_wick_variant_id
        }, 50)

        // Show recommendation message
        if (this.hasWickRecommendationTarget) {
          this.wickRecommendationTarget.innerHTML = `
            <div class="alert alert-info">
              <i class="fa-solid fa-lightbulb"></i>
              Recommended wick: <strong>${variant.recommended_wick_variant_name}</strong>
            </div>
          `
          this.wickRecommendationTarget.style.display = 'block'
        }
      }
    } else {
      // Hide recommendation if no recommended wick
      if (this.hasWickRecommendationTarget) {
        this.wickRecommendationTarget.style.display = 'none'
      }
    }
  }
}

